module.exports = __webpack_public_path__ + "static/media/SAIL_F1.be88ecb9.txt";